<template>
  <form @submit.prevent="submit" autocomplete="off">
    <t-modal-section :title="$t('Device Exception Details')" class="mb-3">
      <b-row>
        <b-col sm="12" md="12" lg="6">
          <b-form-group
            :label="$t('Exception Name')"
            label-for="exception_name"
            :state="$validateState($v.form.name)"
          >
            <b-form-input
              autofocus
              data-test-id="modal-device-exception-name"
              :state="$validateState($v.form.name)"
              id="exception_name"
              @blur="setValidationInput('name', $event.target.value)"
              :placeholder="$t('For example, Exception for Sales users')"
            />

            <template #invalid-feedback>
              <p
                v-if="
                  $v.form.name.$dirty &&
                  $v.form.name.required &&
                  !$v.form.name.minLength
                "
              >
                {{
                  $t("X must be at least X characters long.", {
                    field: $t("Exception Name"),
                    length: $v.form.name.$params.minLength.min,
                  })
                }}
              </p>
              <p v-if="!$v.form.name.required">
                {{ $t("This is a required field.") }}
              </p>
            </template>
          </b-form-group>
        </b-col>

        <b-col sm="12" md="12" lg="6">
          <b-form-group
            :label="$t('Description (optional)')"
            label-for="exception_description"
            :state="$validateState($v.form.description)"
          >
            <b-form-input
              data-test-id="modal-device-exception-description"
              :state="$validateState($v.form.description)"
              id="exception_description"
              @blur="setValidationInput('description', $event.target.value)"
              :placeholder="$t('Exception Description')"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </t-modal-section>
  </form>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { required, ipAddress, minLength } from "vuelidate/lib/validators";

import TModalSection from "@/components/TModalSection";

export default {
  components: {
    TModalSection,
  },
  data() {
    return {
      form: {
        name: null,
        description: null,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(5),
      },
      description: {},
    },
  },
  methods: {
    ...mapMutations("modal", ["userAction", "showModal"]),
    ...mapActions("deviceExceptions", ["createDeviceException"]),
    ...mapActions("toast", ["displayToast"]),
    ipAddress,
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          const response = await this.createDeviceException({
            userId: this.selectedUser.id,
            body: this.form,
          });
          if (response.code === 200) {
            this.displayToast({
              title: this.$t("Success"),
              message: this.$t("Created"),
              duration: 2000,
              variant: "success",
            });
            this.showModal(false);
          }
        } catch (err) {
          console.error(err); // eslint-disable-line no-console
        }
      }
    },
  },
  computed: {
    ...mapGetters("modal", ["modalData"]),
    ...mapGetters("authentication", ["selectedUser"]),
  },
  created() {
    this.userAction(this.submit);
  },
};
</script>
